export interface QuestionOption {
  option: number;
  value: string;
}

export enum QuestionOptionNO {
  questionOptionOne = 1,
  questionOptionTwo = 2,
  questionOptionThree = 3,
  questionOptionFour = 4,
  questionOptionFive = 5,
}

export enum ActiveStatus {
	notBegin = -1,
	begin = 1,
	end = 2,
  }

export interface Answer {
	id: number;
	questionID: number;
	option: string;
	imgUrlSelected: string;
	imgUrlNotSelected: string;
	isSelected: boolean;
}

export interface QuestionData {
	id: number;
	questionImgUrl: string;
	imgUrl: string;
	content: string;
	answers: Answer[];
}

export interface Portraitn {
	id: number;
	name: string;
	imgURL: string;
	character: string;
	characterImgURL: string;
	characterDesc: string;
	resultUrl: string;
	redirectURL: string;
	shopItemID: number
}
export interface RewardDataInfo {
	id: number;
	name: string;
	subname: string;
	pic: string;
	descr: string;
	redirectURL: string;
}

export interface RewardData {
	reward: RewardDataInfo;
	rewardUserID: number;
}

export interface WxConfigData {
	appId: string;
	timestamp: number;
	nonceStr: string;
	signature: string;
}
